import { ViewContainerRef } from '@angular/core';

interface RemoveIllegalCharactersResult {
  value: string;
  hasError: boolean;
}

export abstract class ValidatorBase
{
    private readonly illegalCharacterCheck: RegExp = /[¤£"@%|^*#!;<>½§{}\[\]]/g;
    private readonly lettersCheck: RegExp = /[^\p{L}\s]+/gu;

    public valid: boolean;
    protected elementRef: any;

    public constructor(viewRef: ViewContainerRef)
    {
        this.elementRef = viewRef.element.nativeElement;
    }

    protected abstract isValid(): boolean;

    public sniff(): boolean
    {
        return this.isValid();
    }

    public validate(): boolean
    {
        this.valid = this.isValid();
        return this.valid;
    }

    public get element(): any
    {
        return this.elementRef;
    }

    protected removeIllegalCharacters(value: string): RemoveIllegalCharactersResult {
      if (!value) return { value: '', hasError: false };

      const regex = this.getValidatorRegex();
      const hasError = regex.test(value);
      const cleaned = value
        .replace(regex, ' ')
        .split(' ')
        .filter(part => part.length > 0)
        .join(' ');

      return { value: cleaned, hasError: hasError };
    }

  private getValidatorRegex(): RegExp {
    const validatorKey = this.elementRef?.dataset?.validator;
    const propName = `${validatorKey}Check`;

    // Access the property dynamically using keyof and type assertion
    const regexCandidate: RegExp = (this as any)[propName];
    return regexCandidate instanceof RegExp ? regexCandidate : this.illegalCharacterCheck;
  }
}
